module.exports = __webpack_public_path__ + "static/img/class.c3b2e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/class.png
// module id = qrOr
// module chunks = 1